import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let BodyComp;

class Body extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: BodyComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/body-comp" */
      "../../../components/javascript/zcat-components/body-comp").then(function(res) {
        BodyComp = res.BodyComp;
      })
    );

    
;
  }
}

export { Body };
